
<template>
    
        <mars-view id="recommend-card" class="recommend-card" @click.native="clickRecommendCard"><mars-view :style="{
            'height': picHeight + 'px',
        }"><mars-image class="pic" mode="aspectFill" :src="recommendInfo.pic" @load="picLoad"></mars-image></mars-view><mars-view class="title">{{ recommendInfo.title }}</mars-view><mars-view class="info"><mars-view class="avatar" :style="{'background-image': 'url(' + recommendInfo.avatar + ')'}"></mars-view><mars-view class="name">{{ recommendInfo.name }}</mars-view></mars-view></mars-view>
    
</template>

<script>
/* globals getApp, Page, swan, getCurrentPages, globalData */

import { act } from '../../../static/utils/navigate';
import log from '../../../static/utils/ubcLog';
export default {
  name: 'recommendCard',
  props: {
    recommendInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      picHeight: 260,
      cardWidth: 0
    };
  },
  methods: {
    /**
     * 点击推荐卡片，跳转笔记详情页
     */
    clickRecommendCard() {
      // 推荐笔记点击
      log.send && log.send({
        serverId: 17291,
        area: 'recommend_notes_click',
        action: 'click'
      });
      act({
        type: 'url',
        target: `/pages/note/index?qid=${this.recommendInfo.encodeQid}`
      });
    },
    // 图片加载成功, 计算图片高度
    picLoad(data) {
      let height = data.detail.height;
      let width = data.detail.width;
      const app = getApp();
      const query = app.$api.createSelectorQuery();
      query.select('#recommend-card').boundingClientRect().exec((res = []) => {
        this.cardWidth = res[0] && res[0].width || 0;
        if (this.cardWidth) {
          this.picHeight = height > width ? this.cardWidth * 4 / 3 : this.cardWidth * 3 / 4;
        }
      });
    }
  }
};
</script>

<style scoped>
.recommend-card {
  width: 1.96rem;
  border-radius: 0.09rem;
  background: #fff;
}
.recommend-card .pic {
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 0.09rem 0.09rem 0 0;
}
.recommend-card .title {
  color: #1f1f1f;
  font-size: 0.14rem;
  font-family: PingFang SC;
  font-weight: 500;
  margin: 0.1rem 0.08rem 0.04rem;
  line-height: 0.21rem;
  max-width: 1.8rem;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.recommend-card .info {
  display: flex;
  padding: 0 0.08rem 0.12rem;
  align-items: center;
}
.recommend-card .info .avatar {
  width: 0.18rem;
  height: 0.18rem;
  border-radius: 0.18rem;
  border: 0.5px solid rgba(0, 0, 0, 0.06);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: lightgray;
}
.recommend-card .info .name {
  color: #50525c;
  font-size: 0.12rem;
  font-weight: 400;
  line-height: 1;
  margin-left: 0.06rem;
}

</style>
